import React from 'react'
import TextField from './TextField'
import { Grid, MenuItem } from '@material-ui/core'
import language from 'utils/vast-languagepack'

export default () => (
  <>
    {[
      <TextField
        property="font"
        label={language.signupform.add.labels.fontType}
        select
        selectTemplate={item => (
          <MenuItem key={`formsFormValue${item.value}`} value={item.value}>
            <span style={{ fontSize: 20, fontFamily: item.value }}>
              {item.label}
            </span>
          </MenuItem>
        )}
        items={[
          { value: 'inherit', label: 'inherit' },
          { value: 'Arial', label: 'Arial' },
          { value: 'Arial Black', label: 'Arial Black' },
          { value: 'Bookman', label: 'Bookman' },
          { value: 'Comic Sans MS', label: 'Comic Sans MS' },
          { value: 'Courier New', label: 'Courier New' },
          { value: 'Garamond', label: 'Garamond' },
          { value: 'Georgia', label: 'Georgia' },
          { value: 'Helvetica', label: 'Helvetica' },
          { value: 'Impact', label: 'Impact' },
          { value: 'Open Sans, sans-serif', label: 'Open Sans' },
          { value: 'Palatino', label: 'Palatino' },
          { value: 'Roboto, sans-serif', label: 'Roboto' },
          { value: 'Times New Roman', label: 'Times New Roman' },
          { value: 'Times', label: 'Times' },
          { value: 'Trebuchet MS', label: 'Trebuchet MS' },
          { value: 'Verdana', label: 'Verdana' },
        ].map(font => ({ value: font.value, label: font.label }))}
      />,
      <TextField
        property="textColor"
        label={language.signupform.add.labels.textColor}
        color
      />,
    ].map((textField, idx) => (
      <Grid key={`textFieldFont${idx}`} item xs={12}>
        {textField}
      </Grid>
    ))}
  </>
)
